// import { GetFieldForFilterAndSort } from '../Util/Field';

const AdvancedSearchResultsCollectionFields = [	
];

export default AdvancedSearchResultsCollectionFields;